import { Expose } from "class-transformer";

export class UnassignPlanningBoardTrainingDto {
  @Expose()
  userId: string;
}
